import { getInitials } from '../utils/formatters';
import { getClubAvatarStyle } from '../utils/clubColors';

const sizes = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-12 h-12 text-sm',
  lg: 'w-20 h-20 text-xl',
  xl: 'w-32 h-32 text-3xl',
  '2xl': 'w-48 h-48 text-5xl',
};

const largeVariants = new Set(['xl', '2xl']);

export default function InitialsAvatar({ name, clubName, size = 'sm' }) {
  const initials = getInitials(name);
  const clubStyle = getClubAvatarStyle(clubName);

  // Neutral surface with volt ring when no club colours are available
  const fallback = `${sizes[size]} bg-surface-container-high text-on-surface ring-1 ring-primary/60 flex items-center justify-center font-headline font-bold select-none`;

  if (largeVariants.has(size)) {
    if (clubStyle) {
      return (
        <div className={`${sizes[size]} rounded-2xl p-[2px]`} style={{ background: clubStyle.background, boxShadow: clubStyle.boxShadow }}>
          <div className="w-full h-full rounded-2xl flex items-center justify-center font-headline font-bold select-none border border-white/10" style={clubStyle}>
            {initials}
          </div>
        </div>
      );
    }

    return <div className={`${fallback} rounded-2xl`}>{initials}</div>;
  }

  if (clubStyle) {
    return (
      <div
        className={`${sizes[size]} rounded-xl flex items-center justify-center font-headline font-bold select-none border`}
        style={clubStyle}
        title={clubName}
      >
        {initials}
      </div>
    );
  }

  return <div className={`${fallback} rounded-xl`}>{initials}</div>;
}
